import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './admin.css';
import { useScrollBehavior } from './useScrollBehavior.js';
import useScheduleAppointment from './useScheduleAppointment5.js';
//import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Calendar from 'react-calendar';
import { PiPhoneCallBold } from 'react-icons/pi';
//import { saveAs } from 'file-saver';
import ICAL from 'ical.js';

const SignUp = () => {

  useScrollBehavior();

	const { scheduleAppointment, getAppointments, deleteAppointment, 
    getBlockedTimes, blockTimeSlot, deleteBlockedTime, blockTime, loading, error, success, appointments } = useScheduleAppointment();
  	const [title, setTitle] = useState('');
    const [name, setName] = useState('');
  	const [date, setDate] = useState('');
  	const [description, setDescription] = useState('');
	  const [adminBlockDate, setAdminBlockDate] = useState(null);
    const [message, setMessage] = useState('');
    const [isAllDay, setIsAllDay] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [blockedTimeSlots, setBlockedTimeSlots] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [address, setAddress] = useState('');
    //const [appointments(), setAppointments] = useState([]);
    //const [getBlockedTimes(), setBlockedTimes] = useState([]);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
    const [loginUsername, setLoginUsername] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [loginErrorMessage, setLoginErrorMessage] = useState('');
    const [newUserUsername, setNewUserUsername] = useState('');
    const [newUserPassword, setNewUserPassword] = useState('');
    const [registrationMessage, setRegistrationMessage] = useState('');
    const [users, setUsers] = useState([]);

    
    
    useEffect(() => {
      // Check if user is already logged in (e.g., check for token)
      const token = localStorage.getItem('adminToken'); // Example token name
      if (token) {
          setIsUserLoggedIn(true);
      } else {
          setIsLoginPopupOpen(true);
      }
  }, []);

  /*useEffect(() => {
  // TEMPORARILY bypass login
  setIsUserLoggedIn(true);
  setIsLoginPopupOpen(false);
}, []);*/



  const handleAdminLogin = async () => {
      try {
          const response = await axios.post('https://api.samstreeservice.com/api/admin/login', {
              username: loginUsername,
              password: loginPassword,
          });

          if (response.data.token) {
              localStorage.setItem('adminToken', response.data.token); // Store token
              setIsUserLoggedIn(true);
              setIsLoginPopupOpen(false);
              setLoginErrorMessage('');
          } else {
              setLoginErrorMessage('Login failed. Please check your credentials.');
          }
      } catch (error) {
          console.error('Login error:', error);
          setLoginErrorMessage('An error occurred during login.');
      }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken'); // Clear token
    setIsUserLoggedIn(false);
    setIsLoginPopupOpen(true);
};

const handleUserRegistration = async () => {
  try {
      const response = await axios.post('https://api.samstreeservice.com/api/admin/register', {
          username: newUserUsername,
          password: newUserPassword,
      });

      setRegistrationMessage(response.data.message); // Display success or error message
  } catch (error) {
      setRegistrationMessage('Registration failed.');
  }
};


const fetchUsers = async () => {
  try {
      const response = await axios.get('https://api.samstreeservice.com/api/admin/users');
      setUsers(response.data);
  } catch (error) {
      console.error('Error fetching users:', error);
  }
};

useEffect(() => {
  if (isUserLoggedIn) {
      fetchUsers();
  }
}, [isUserLoggedIn]); // Fetch users when logged in

const deleteUser = async (userId) => {
  try {
      await axios.delete(`https://api.samstreeservice.com/api/admin/users/${userId}`);
      fetchUsers(); // Refresh user list
  } catch (error) {
      console.error('Error deleting user:', error);
  }
};

    
    const fetchData = async () => {
      try {
        const response = await axios.get('https://api.samstreeservice.com/api/test');
        console.log(response.data); // Log the response from your backend
      } catch (error) {
        console.error('There was an error!', error);
      }
    };

    useEffect(() => {
      fetchData();
    }, []);

    useEffect(() => {
      setBlockedTimeSlots(getBlockedTimes()); // Use state accessor
    }, [getBlockedTimes]);

  // Handle date selection
  const handleDateClick = (date) => {
    setSelectedDate(date);  // Set the clicked date
  };
  
  const handleBlockTime = async () => {
    if (!adminBlockDate) {
      setMessage('Please select a date and time to block.');
      return;
    }

    if (isAllDay) {
			// Block every 30 minutes for the entire day
			const dayStart = new Date(adminBlockDate).setHours(0, 0, 0, 0);
			const dayEnd = new Date(adminBlockDate).setHours(23, 59, 59, 999);

      const times = [];
			for (let time = dayStart; time <= dayEnd; time += 30 * 60 * 1000) { // 30-minute increments
				 blockTimeSlot(new Date(time));
        }
    
        // Block all times in bulk
        for (const time of times) {
          blockTimeSlot(time);
        }
		} else {
			blockTimeSlot(adminBlockDate);
		}
    
    //await blockTimeSlot(adminBlockDate);
    //blockTimeSlot(adminBlockDate);
    setMessage(isAllDay ? 'Full day blocked successfully!' : 'Time blocked successfully!');
    setAdminBlockDate(null);
  };


  const bookedDates = appointments().map((appt) => new Date(appt.date).setHours(0, 0, 0, 0));
  const bookedTimesForDate = (selectedDate) => appointments().filter((appt) => new Date(appt.date).toDateString() === selectedDate.toDateString()).map((appt) => new Date(appt.date));

  const blockedDates = getBlockedTimes().map((blocked) => new Date(blocked.date).setHours(0, 0, 0, 0));
  const blockedTimesForDate = (selectedDate) => getBlockedTimes().filter((blocked) => new Date(blocked.date).toDateString() === selectedDate.toDateString()).map((blocked) => new Date(blocked.date));


  const isFullyBooked = (date) => {
    const dayStart = new Date(date).setHours(0, 0, 0, 0);
    const dayEnd = new Date(date).setHours(23, 59, 59, 999);
  

    const bookedSlots = appointments().filter((appointment) => {
      const appointmentDate = new Date(appointment.date).getTime();
      return appointmentDate >= dayStart && appointmentDate <= dayEnd;
    });
  
  
    // Assuming 48 slots for a full day, return true if all slots are booked
    return bookedSlots.length >= 48;
  };

  const isPartiallyBooked = (date) => {
    const dayStart = new Date(date).setHours(0, 0, 0, 0);
    const dayEnd = new Date(date).setHours(23, 59, 59, 999);
  

    const bookedSlots = appointments().filter((appointment) => {
      const appointmentDate = new Date(appointment.date).getTime();
      return appointmentDate >= dayStart && appointmentDate <= dayEnd;
    });
  
    return bookedSlots.length > 0 && bookedSlots.length < 48; // Some slots booked but not all
  };
  
  const isPartiallyBlocked = (date) => {
    const dayStart = new Date(date).setHours(0, 0, 0, 0);
    const dayEnd = new Date(date).setHours(23, 59, 59, 999);
  
    const blockedSlots = getBlockedTimes().filter((blocked) => {
      const blockedTime = new Date(blocked.date).getTime();
      return blockedTime >= dayStart && blockedTime <= dayEnd;
    });
  
    // Return true if there are any blocked slots but not all
    return blockedSlots.length > 0 && blockedSlots.length < 48;
  };
  
  const isFullBlocked = (date) => {
    const dayStart = new Date(date).setHours(0, 0, 0, 0);
    const dayEnd = new Date(date).setHours(23, 59, 59, 999);
  

    const blockedSlots = getBlockedTimes().filter((blocked) => {
      const blockedTime = new Date(blocked.date).getTime();
      return blockedTime >= dayStart && blockedTime <= dayEnd;
    });
  
  
    // If all time slots are blocked, return true
    return blockedSlots.length >= 48;
  };
  

  const excludeTimes = [
  // Convert the booked and blocked times to Date objects for comparison
  ...bookedDates.map(timestamp => new Date(timestamp)),
  ...blockedDates.map(timestamp => new Date(timestamp)),
];





const handleAllDayToggle = async () => {
    if (!selectedDate) {
      setMessage('Please select a date first.');
    return;
  }
    
  const dayStart = new Date(selectedDate);
  dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(selectedDate);
  dayEnd.setHours(23, 59, 59, 999);

// Block all times in the day (for example, every 30 minutes)
    for (let time = dayStart.getTime(); time <= dayEnd.getTime(); time += 30 * 60 * 1000) {
      //blockTimeSlot(new Date(time));
      await blockTimeSlot(new Date(time));
      }

      setMessage('Full day blocked successfully!');
      // Refresh blocked times
      const updatedBlockedTimeSlots = getBlockedTimes();
      setBlockedTimeSlots(updatedBlockedTimeSlots);
      /*const updatedBlockedTimes = await getBlockedTimes();
      setBlockedTimes(updatedBlockedTimes);
      setBlockedTimeSlots(updatedBlockedTimes);*/
    };


    const handleUnblockAllDay = async () => {
      if (!selectedDate) {
        setMessage('Please select a date first.');
        return;
      }
    
      // Get the start and end of the day for the selected date
      const dayStart = new Date(selectedDate);
      dayStart.setHours(0, 0, 0, 0);
      const dayEnd = new Date(selectedDate);
      dayEnd.setHours(23, 59, 59, 999);
    

      const timesToDelete = blockedTimeSlots.filter(blockedTime => {
        const blockDate = new Date(blockedTime.date);
        return blockDate >= dayStart && blockDate <= dayEnd;
      });
      let currentBlockedTimes = [...getBlockedTimes()]; 
  
      for (const time of timesToDelete) {
        await deleteBlockedTime(time.date);
      }
      
      setMessage('Full day unblocked successfully!');
     

      setMessage('Full day unblocked successfully!');
    };

    const sortedAppointments = () => {
      return appointments().slice().sort((a, b) => new Date(a.date) - new Date(b.date));
  };

 
  const generateWebCalLink = async () => {
    try {
      const calendarUrl = 'https://api.samstreeservice.com/calendar-feed.ics';
      // Your original .ics URL
        const response = await fetch(calendarUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.text();
        const jcalData = ICAL.parse(data);
        const comp = new ICAL.Component(jcalData);
        const vevents = comp.getAllSubcomponents('vevent');

        const events = vevents.map(vevent => {
            const event = new ICAL.Event(vevent);
            return {
                summary: event.summary,
                start: event.startDate.toJSDate(),
                end: event.endDate.toJSDate(),
            };
        });

        // The webcal link is the same as the original link
        const webcalLink = `webcal://api.samstreeservice.com/calendar-feed.ics`;


        return webcalLink; // Return the webcal link
    } catch (error) {
        console.error("Failed to fetch or parse events:", error);
        return null; // Return null in case of error
    }
};


return (
  <div id='admin_div'>
      {isLoginPopupOpen && (
          <div id="login-popup">
              <h2>Admin Login</h2>
              <input
                  type="text"
                  placeholder="Username"
                  value={loginUsername}
                  onChange={(e) => setLoginUsername(e.target.value)}
              />
              <input
                  type="password"
                  placeholder="Password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
              />
              <button onClick={handleAdminLogin}>Login</button>
              {loginErrorMessage && <p style={{ color: 'red' }}>{loginErrorMessage}</p>}
          </div>
      )}

      {/* --- CHANGE: WRAP ENTIRE ADMIN CONTENT IN CONDITIONAL --- */}
      {isUserLoggedIn && (
          <div> {/* Added a wrapping div */}
              <div id='cover_div_admin'>
                  <div className='module_admin' id='module_1'>
                      <div id='Admin_heading'>
                          <h1>Admin Calendar</h1>
                      </div>
                  </div>
                  <div id='calendar_contianer' className='module_admin'>
                      <div id="calendar_div">
                          <h3>Appointment Calendar</h3>
                          <Calendar
                              onClickDay={handleDateClick}
                              tileClassName={({ date }) => {
                                  if (isFullyBooked(date)) {
                                      return 'booked-day';
                                  } else if (isPartiallyBooked(date)) {
                                      return 'partially-booked-day';
                                  } else if (isFullBlocked(date)) {
                                      return 'full-blocked-day';
                                  } else if (isPartiallyBlocked(date)) {
                                      return 'blocked-day';
                                  }
                                  return '';
                              }}
                              tileContent={({ date, view }) => {
                                  const appts = appointments().filter(
                                      (appt) => new Date(appt.date).toDateString() === date.toDateString()
                                  );
                                  return (
                                      <div id="appointment-count-container">
                                          {appts.length > 0 && <span>{appts.length} Appt</span>}
                                      </div>
                                  );
                              }}
                          />
                      </div>
                      <div id="appointment_div2" className='module_admin'>
                          <h3>Scheduled Appointments</h3>
                          <div className="appointment-list">
                              {sortedAppointments().map((appointment) => (
                                  <div key={appointment.id} className="appointment-item">
                                      <div className="appointment-info">
                                          <div className="appointment-name">
                                              <strong>{appointment.name}</strong>
                                          </div>
                                          <div className="appointment-date">
                                              {new Date(appointment.date).toLocaleString()}
                                          </div>
                                          <div className="appointment-address">
                                              {appointment.address}
                                          </div>
                                          <div className="appointment-contact">
                                              <div className="appointment-phone">
                                                  {appointment.phoneNumber}
                                              </div>
                                              <div id="contact_app" onClick={() => window.location.href = `tel:${appointment.phoneNumber}`}>
                                                  <div id="circle_icon_contact_app"><PiPhoneCallBold /></div>
                                              </div>
                                          </div>
                                          <button onClick={() => deleteAppointment(appointment.id)} className="delete-button">
                                              Delete
                                          </button>
                                      </div>
                                  </div>
                              ))}
                          </div>
                          <div id='add_calendar' onClick={async () => {
                              const webcalLink = await generateWebCalLink();
                              if (webcalLink) {
                                  window.location.href = webcalLink;
                              }
                          }}>Add to Calendar</div>
                      </div>
                      {error && <p style={{ color: 'red' }}>Error: {error.message}</p>}
                      {success && <p style={{ color: 'white' }}>Appointment scheduled successfully!</p>}
                  </div>
                  {selectedDate && (
                      <div id="day-modal">
                          <div id='content_wrapper'>
                              <button className="close_button10" onClick={() => setSelectedDate(null)}>
                                  &times;
                              </button>
                              <div className="modal-content8">
                                  <h2>{selectedDate.toLocaleDateString()}</h2>
                                  <div>
                                      <button id='handleAllDayToggle' onClick={handleAllDayToggle}>
                                          Block All Times
                                      </button>
                                      <button id='handleUnblockAllDay' onClick={handleUnblockAllDay}>
                                          Unblock All Times
                                      </button>
                                  </div>
                                  <h4>Available Times:</h4>
                                  <ul>
                                      {Array.from({ length: 9 }, (_, i) => {
                                          const slotTime = new Date(selectedDate);
                                          slotTime.setHours(8 + i, 0, 0, 0);
                                          const formattedTime = slotTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                                          const isBlocked = blockedTimesForDate(selectedDate).some((blocked) => new Date(blocked).toTimeString() === slotTime.toTimeString());
                                          const bookedSlot = appointments().find((appt) => new Date(appt.date).toLocaleDateString() === selectedDate.toLocaleDateString() && new Date(appt.date).toTimeString() === slotTime.toTimeString());
                                          return (
                                              <li key={`${selectedDate.toISOString()}-${i}`} style={{ padding: '5px 0', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between' }}>
                                                  <div>
                                                      <strong>{formattedTime}</strong>
                                                      {isBlocked ? (<p style={{ color: 'red' }}>Blocked</p>) : bookedSlot ? (<div><p>Booked by: <strong>{bookedSlot.name}</strong></p><p>Phone: {bookedSlot.phoneNumber}</p><p>Email: {bookedSlot.email}</p><p>Address: {bookedSlot.address}</p></div>) : (<p>Available</p>)}
                                                  </div>
                                                  {bookedSlot && (<button onClick={() => deleteAppointment(bookedSlot.id)} style={{ backgroundColor: 'red', color: 'white', padding: '5px', border: 'none', borderRadius: '5px' }}>Delete</button>)}
                                                  {isBlocked && (<button onClick={async () => { await deleteBlockedTime(slotTime.toISOString()); setBlockedTimeSlots(getBlockedTimes()); }} style={{ backgroundColor: 'green', color: 'white', padding: '5px', border: 'none', borderRadius: '5px' }}>Unblock</button>)}
                                                  {!isBlocked && !bookedSlot && (<button onClick={() => blockTime(slotTime)} style={{ backgroundColor: 'blue', color: 'white', padding: '5px', border: 'none', borderRadius: '5px' }}>Block Time</button>)}
                                              </li>
                                          );
                                      })}
                                  </ul>
                              </div>
                          </div>
                      </div>
                  )}
                  {error && <p style={{ color: 'red' }}>Error: {error.message}</p>}
                  {success && <p style={{ color: 'white' }}>Appointment scheduled successfully!</p>}
              </div>
              <div id='registration_div'>
                  <div className="user-registration">
                      <h2>Create New User</h2>
                      <input type="text" placeholder="New Username" value={newUserUsername} onChange={(e) => setNewUserUsername(e.target.value)} />
                      <input type="password" placeholder="New Password" value={newUserPassword} onChange={(e) => setNewUserPassword(e.target.value)} />
                      <button onClick={handleUserRegistration}>Register User</button>
                      {registrationMessage && <p>{registrationMessage}</p>}
                  </div>
                  <div className="user-list">
                      <h2>User List</h2>
                      <ul>
                          {users.map((user) => (
                              <li key={user.id}>
                                  <span>{user.username} (Admin: {user.isAdmin ? 'Yes' : 'No'})</span>
                                  <button onClick={() => deleteUser(user.id)}>Delete</button>
                              </li>
                          ))}
                      </ul>
                  </div>
                  <div id='logout' onClick={handleLogout}>Logout</div>
              </div>
          </div>
      )}
      {/* --- END OF CONDITIONAL WRAPPING --- */}
  </div>
);
};
	

export default SignUp;

